import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { CategorySelect } from '../CategorySelect'

function CategorySelectFormikField({ Select = CategorySelect, ...restProps }) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default CategorySelectFormikField
